export default __webpack_public_path__ + "static/media/Brand_Oval_Info.7be88814.png";